import React from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose(): void;
    modalHeader: string;
    note: string;
}

function InvalidCertificateModal({ isOpen, modalHeader, note, onClose }: ConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
    <ModalOverlay className='confirmation-modal__overlay' />
    <ModalContent className='confirmation-modal'>
      <ModalHeader className='confirmation-modal__header'>
      {modalHeader}
        <button className='transfer-create-modal__close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>
      </ModalHeader>
      <ModalBody className='confirmation-modal__body' padding="40px 38.5px">
        <Text fontSize='' color=''>{note}</Text>
      </ModalBody>
      <ModalFooter mt={3} className='confirmation-modal__footer'>
        <Button
          onClick={onClose}
          className='confirmation-modal__primary-btn'
        >
          Okay
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
  )
}

export default InvalidCertificateModal
